<mat-form-field subscriptSizing="dynamic">
  <mat-label>Find a template</mat-label>
  <input matInput [formControl]="searchCtrl" />
</mat-form-field>

<div
  class="h-56 overflow-y-auto overflow-x-scroll rounded-md border border-solid border-slate-200"
>
  @for (template of searchFilter.results$ | async; track template.name) {
    <div
      class="flex cursor-pointer flex-row items-center gap-2 px-4 py-2"
      matRipple
      (click)="selectTemplate(template)"
    >
      @if (selectedTemplate() === template) {
        <mat-icon color="primary" class="shrink-0"
          >radio_button_checked</mat-icon
        >
      } @else {
        <mat-icon class="shrink-0">radio_button_unchecked</mat-icon>
      }
      <div class="flex grow flex-col">
        <div class="text-sm font-bold">{{ template.name }}</div>
        <div class="text-xs text-slate-500">
          {{ template.description }}
        </div>
      </div>
      <mat-icon
        #overlayTarget="cdkOverlayOrigin"
        cdkOverlayOrigin
        class="icon-sm shrink-0 opacity-50"
        >info</mat-icon
      >
      <pt-custom-tooltip
        [target]="overlayTarget"
        [positions]="tooltipPositions"
      >
        <ng-template ptCustomTooltipContent>
          <div class="flex flex-col gap-4 p-4">
            <div>
              <h3 class="!m-0 !font-bold">{{ template.name }}</h3>
              <div>{{ template.description }}</div>
            </div>
            <pr-campaign-entry-summary
              [campaign]="template.campaign"
              [stepSummary]="template | map: getStepSummary : this | async"
            />
            <pr-campaign-enrolment-summary [campaign]="template.campaign" />

            @if (template.report) {
              <pr-campaign-report-summary [customReport]="template.report">
                This report will be created and used to enroll entries in the
                Campaign Run.
              </pr-campaign-report-summary>
            } @else {
              <pr-file-upload-summary />
            }
          </div>
        </ng-template>
      </pt-custom-tooltip>
    </div>
  } @empty {
    <pr-empty-state image="list" title="Templates Found" />
  }
</div>
